// import { useContext, useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import Select from "react-select";
// import { toast } from "react-toastify";

// export default function TaskForm({
//   leadId,
//   showTaskForm,
//   onTaskCreated,
//   setOpenForm = null,
// }) {
//   const { user } = useContext(AuthContext);
//   const [users, setUsers] = useState([]);
//   const [statuses, setStatuses] = useState([]); // Store fetched statuses
//   const [labels, setLabels] = useState([]); // Store fetched labels
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [emailError, setEmailError] = useState("");
//   const [formData, setFormData] = useState({
//     companyId: user.accountType === "COMPANY" ? user.id : user.companyId,
//     subject: "",
//     priority: "Low",
//     statusName: "",
//     statusColor: "",
//     labelName: "",
//     labelColor: "",
//     // startDate: "",
//     endDate: "",
//     description: "",
//     file: null,
//     createdById: user?.id,
//     createdByName: user?.name,
//     leadId: leadId || "",
//     participants: [],
//   });
//   const [participantEmail, setParticipantEmail] = useState("");
//   const [showNotifyModal, setShowNotifyModal] = useState(false);
//   const [pendingParticipant, setPendingParticipant] = useState(null);
//   const fileInputRef = useRef(null);

//   // Allowed mime types & max size (bytes)
//   // Update this constant near the top of the component
// const ALLOWED_TYPES = [
//   "image/png",
//   "image/jpeg",
//   "application/pdf",
//   "application/msword", // .doc
//   "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
//   "text/plain", // .txt
//   "text/csv", // .csv
//   "application/vnd.ms-excel", // .xls
//   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
// ];
//   const MAX_SIZE = 10 * 1024 * 1024; // 5 MB

//   // Clipboard-paste listener (mount once)
//   useEffect(() => {
//     function handlePaste(e) {
//       const item = [...e.clipboardData.items].find(
//         (i) => i.kind === "file" && i.type.startsWith("image/")
//       );
//       if (!item) return; // nothing to do

//       const file = item.getAsFile();
//       if (!file) return;

//       // size check
//       // In the useEffect for clipboard paste
// if (file.size > MAX_SIZE) {
//   toast.error("Image exceeds 10 MB limit");
//   return;
// }

//       // save into your formData
//       setFormData((prev) => ({ ...prev, file }));

//       // OPTIONAL: point the hidden file input to the new file so
//       // the browser's "chosen file" label shows something
//       if (fileInputRef.current) {
//         const dt = new DataTransfer();
//         dt.items.add(file);
//         fileInputRef.current.files = dt.files;
//       }

//       toast.success("Screenshot pasted!");
//     }

//     window.addEventListener("paste", handlePaste);
//     return () => window.removeEventListener("paste", handlePaste);
//   }, []);

//   useEffect(() => {
//     async function fetchStatusAndLabel() {
//       const companyId =
//         user?.accountType === "COMPANY" ? user.id : user?.companyId;
//       // if (!companyId) return;

//       try {
//         const statusResponse = await axios.get(
//           `${API_URL}/api/taskStatus/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         );

//         const labelResponse = await axios.get(
//           `${API_URL}/api/taskLabel/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         );

//         setStatuses(statusResponse.data);
//         setLabels(labelResponse.data);
//       } catch (error) {
//         console.error("Error fetching statuses and labels:", error);
//       }
//     }
//     fetchStatusAndLabel();
//   }, [user]);

//   // Fetch Users
//   useEffect(() => {
//     async function fetchUsers() {
//       if (!user?.id || !user?.accountType) return;
//       const url =
//         user?.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       try {
//         const response = await fetch(url, {
//           method: "GET",
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const data = await response.json();
//         setUsers(data);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }
//     fetchUsers();
//   }, [user]);

//   // Handle Form Change
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleAssignedUsersChange = (selectedOptions) => {
//     const assignedUsers = selectedOptions.map((option) => ({
//       id: option.value,
//       name: option.label,
//     }));

//     setFormData({
//       ...formData,
//       assignedToJson: JSON.stringify(assignedUsers),
//     });
//   };

//   // Handle Submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     try {
//       const taskData = new FormData();
//       Object.keys(formData).forEach((key) => {
//         if (formData[key] !== null && formData[key] !== undefined) {
//           taskData.append(key, formData[key]);
//         }
//       });

//       const response = await axios.post(`${API_URL}/api/tasks`, taskData, {
//         headers: {
//           authorization: `Bearer ${localStorage.getItem("token")}`,
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       if (response.data?.status === "Successful") {
//         toast.success(response.data.message, {
//           position: "top-center",
//           autoClose: 5000,
//         });

//         // Reset form
//         setFormData({
//           companyId: user.accountType === "COMPANY" ? user.id : user.companyId,
//           subject: "",
//           priority: "Low",
//           statusName: "",
//           statusColor: "",
//           labelName: "",
//           labelColor: "",
//           endDate: "",
//           assignedToJson: JSON.stringify([]),
//           description: "",
//           file: null,
//           createdById: user?.id,
//           createdByName: user?.name,
//           leadId: leadId || "",
//           participants: [],
//         });

//         window.dispatchEvent(new Event("taskCreated"));

//         // Callbacks
//         onTaskCreated?.(response.data);
//         showTaskForm?.(false);
//         setOpenForm?.(null);
//       } else {
//         toast.error(response.data?.message);
//       }
//     } catch (error) {
//       console.error("Task creation error:", error);
//       toast.error(error.response?.data?.message || error.message, {
//         position: "top-center",
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // Add Participant Handler
//   const handleAddParticipant = () => {
//     setEmailError(""); // Clear previous errors

//     if (!participantEmail) {
//       setEmailError("Please enter an email address");
//       return;
//     }

//     // Basic email validation
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(participantEmail)) {
//       setEmailError("Please enter a valid email address");
//       return;
//     }

//     // Check for duplicate emails
//     const isDuplicate = formData.participants.some((participant) => {
//       const email = Array.isArray(participant)
//         ? participant[1] || participant[0]
//         : participant;
//       return email.toLowerCase() === participantEmail.toLowerCase();
//     });

//     if (isDuplicate) {
//       setEmailError("This email is already added");
//       return;
//     }

//     const matchedUser = users.find(
//       (u) => u.email.toLowerCase() === participantEmail.toLowerCase()
//     );
//     if (matchedUser) {
//       setPendingParticipant({ id: matchedUser.id, email: participantEmail });
//       setShowNotifyModal(true);
//     } else {
//       setFormData((prev) => ({
//         ...prev,
//         participants: [...prev.participants, [participantEmail]],
//       }));
//       setParticipantEmail("");
//     }
//   };

//   // Confirm Notification Choice
//   const confirmParticipant = (type) => {
//     let entry =
//       type === "both"
//         ? [pendingParticipant.id, pendingParticipant.email]
//         : [pendingParticipant.email];

//     setFormData((prev) => ({
//       ...prev,
//       participants: [...prev.participants, entry],
//     }));

//     setShowNotifyModal(false);
//     setPendingParticipant(null);
//     setParticipantEmail("");
//   };

//   // Filter active statuses for dropdown
//   const activeStatuses = statuses.filter(status => status.active === true);

//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="grid gap-4 p-4 w-full max-w-4xl mx-auto bg-white rounded-lg shadow-sm dark:bg-gray-800 "
//     >
//       {/* Subject Field */}
//       <div className="w-full">
//         <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//           Subject
//         </label>
//         <input
//           type="text"
//           name="subject"
//           value={formData.subject}
//           onChange={handleChange}
//           className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
//           placeholder="Subject"
//         />
//       </div>

//       {/* Priority, Status, Label Row */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 dark:text-white">
//         {/* Priority */}
//         <div className="w-full">
//           <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//             Priority
//           </label>
//           <select
//             name="priority"
//             value={formData.priority}
//             onChange={handleChange}
//             className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 App dark:bg-gray-700 dark:text-white"
//           >
//             <option value="Low">Low</option>
//             <option value="Medium">Medium</option>
//             <option value="High">High</option>
            
//           </select>
//         </div>

//         {/* Status */}
//         <div className="w-full">
//           <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//             Status
//           </label>
//           <select
//             name="statusName"
//             value={formData.statusName}
//             onChange={(e) => {
//               const selectedStatus = activeStatuses.find(
//                 (status) => status.name === e.target.value
//               );
//               setFormData({
//                 ...formData,
//                 statusName: e.target.value,
//                 statusColor: selectedStatus ? selectedStatus.color : "",
//               });
//             }}
//             className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 App dark:bg-gray-700 dark:text-white"
//           >
//             <option value="">Select Status</option>
//             {activeStatuses.map((status) => (
//               <option
//                 key={status.taskStatusId || status.id}
//                 value={status.name}
//                 // style={{ backgroundColor: status.color, color: "white" }}
//               >
//                 {status.name}
//               </option>
//             ))}
//           </select>
//           {formData.statusColor && (
//             <div
//               className="w-8 h-4 mt-2 rounded"
//               style={{ backgroundColor: formData.statusColor }}
//             ></div>
//           )}
//         </div>

//         {/* Label */}
//         <div className="w-full">
//           <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//             Label (Optional)
//           </label>
//           <select
//             name="labelName"
//             value={formData.labelName}
//             onChange={(e) => {
//               const selectedLabel = labels.find(
//                 (label) => label.name === e.target.value
//               );
//               setFormData({
//                 ...formData,
//                 labelName: e.target.value,
//                 labelColor: selectedLabel ? selectedLabel.color : "",
//               });
//             }}
//             className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 App dark:bg-gray-700 dark:text-white"
//           >
//             <option value="">Select Label</option>
//             {labels.map((label) => (
//               <option key={label.id} value={label.name}>
//                 {label.name}
//               </option>
//             ))}
//           </select>
//           {formData.labelColor && (
//             <div
//               className="w-8 h-4 mt-2 rounded"
//               style={{ backgroundColor: formData.labelColor }}
//             ></div>
//           )}
//         </div>
//       </div>

//       {/* Date Fields */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//         <div className="w-full">
//           <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//             End Date
//           </label>
//           <input
//             type="date"
//             name="endDate"
//             value={formData.endDate}
//             onChange={handleChange}
//             min={new Date().toISOString().split("T")[0]}
//             className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
//           />
//         </div>
//       </div>

//       {/* Assign To */}
//       <div className="w-full">
//         <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//           Assign To
//         </label>
//         <Select
//           isMulti
//           name="assignedToJson"
//           options={users.map((user) => ({
//             value: user.id,
//             label: `${user.fname} ${user.lname}`,
//           }))}
//           onChange={handleAssignedUsersChange}
//           className="w-full p-2 dark:bg-gray-700"
//           classNamePrefix="select"
//           styles={{
//             control: (base, state) => ({
//               ...base,
//               minHeight: "42px",
//               padding: "2px 4px",
//               borderRadius: "0.375rem", // Tailwind rounded-md
//               borderColor: "#d1d5db", // Tailwind gray-300
//               backgroundColor: document.documentElement.classList.contains(
//                 "dark"
//               )
//                 ? "#374151" // Tailwind gray-700
//                 : "white",
//               color: document.documentElement.classList.contains("dark")
//                 ? "white"
//                 : "black",
//               boxShadow: state.isFocused ? "0 0 0 1px #60a5fa" : "none", // Tailwind blue-400
//               "&:hover": {
//                 borderColor: "#9ca3af", // Tailwind gray-400
//               },
//             }),
//             menu: (base) => ({
//               ...base,
//               borderRadius: "0.375rem",
//               marginTop: 4,
//               backgroundColor: document.documentElement.classList.contains(
//                 "dark"
//               )
//                 ? "#1f2937" // Tailwind gray-800
//                 : "white",
//               color: document.documentElement.classList.contains("dark")
//                 ? "white"
//                 : "black",
//             }),
//             option: (base, { isFocused, isSelected }) => ({
//               ...base,
//               backgroundColor: isFocused
//                 ? document.documentElement.classList.contains("dark")
//                   ? "#4b5563" // Tailwind gray-600
//                   : "#f3f4f6" // Tailwind gray-100
//                 : isSelected
//                 ? "#60a5fa" // Tailwind blue-400
//                 : "transparent",
//               color: document.documentElement.classList.contains("dark")
//                 ? "white"
//                 : "black",
//               cursor: "pointer",
//             }),
//             multiValue: (base) => ({
//               ...base,
//               backgroundColor: document.documentElement.classList.contains(
//                 "dark"
//               )
//                 ? "#6b7280" // Tailwind gray-500
//                 : "#e5e7eb", // Tailwind gray-200
//               borderRadius: "0.375rem",
//               padding: "2px 6px",
//             }),
//             multiValueLabel: (base) => ({
//               ...base,
//               color: document.documentElement.classList.contains("dark")
//                 ? "white"
//                 : "black",
//             }),
//             multiValueRemove: (base) => ({
//               ...base,
//               color: "#ef4444", // Tailwind red-500
//               ":hover": {
//                 backgroundColor: "#f87171", // red-400
//                 color: "white",
//               },
//             }),
//           }}
//         />
//       </div>

//       {/* Participant Email Input */}
//       <div className="w-full">
//         <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//           Participant Email
//         </label>
//         <div className="flex gap-2">
//           <input
//             type="email"
//             value={participantEmail}
//             onChange={(e) => {
//               setParticipantEmail(e.target.value);
//               setEmailError(""); // Clear error when typing
//             }}
//             className={`w-full p-2 border rounded-md dark:bg-gray-700 ${
//               emailError ? "border-red-500" : "border-gray-300"
//             }`}
//             placeholder="Add participant email"
//           />
//           <button
//             type="button"
//             onClick={handleAddParticipant}
//             className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//           >
//             Add
//           </button>
//         </div>
//         {emailError && (
//           <p className="mt-1 text-sm text-red-600 dark:text-red-400">
//             {emailError}
//           </p>
//         )}
//       </div>

//       {/* List of Added Participants */}
//       {formData.participants.length > 0 && (
//         <div className="mt-2 space-y-1">
//           {formData.participants.map((participant, index) => {
//             const email = Array.isArray(participant)
//               ? participant[1] || participant[0]
//               : participant;
//             return (
//               <div
//                 key={index}
//                 className="flex items-center justify-between bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded-md"
//               >
//                 <span className="text-sm text-gray-800 dark:text-white">
//                   {email}
//                 </span>
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setFormData((prev) => ({
//                       ...prev,
//                       participants: prev.participants.filter(
//                         (_, i) => i !== index
//                       ),
//                     }));
//                   }}
//                   className="text-red-500 hover:text-red-700 text-sm"
//                   title="Remove"
//                 >
//                   ❌
//                 </button>
//               </div>
//             );
//           })}
//         </div>
//       )}
//       {/* Description */}
//       <div className="w-full">
//         <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//           Description
//         </label>
//         <textarea
//           name="description"
//           value={formData.description}
//           onChange={handleChange}
//           required
//           className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 min-h-[100px] dark:bg-gray-700"
//           placeholder="Enter description"
//         ></textarea>
//       </div>

//       {/* File Upload */}
//       <div className="w-full">
//         <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//           Upload File
//         </label>

//         {/* FILE INPUT */}
//         <input
//           ref={fileInputRef}
//           type="file"
//           name="file"
//           accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,.txt,.csv,.xls,.xlsx"
//           onChange={(e) => {
//             const file = e.target.files[0];
//             if (!file) return;

//             if (!ALLOWED_TYPES.includes(file.type)) {
//               toast.error("Unsupported file type");
//               e.target.value = ""; // reset chooser
//               return;
//             }
//             if (file.size > MAX_SIZE) {
//               toast.error("File exceeds 10 MB limit");
//               e.target.value = "";
//               return;
//             }

//             setFormData((prev) => ({ ...prev, file }));
//           }}
//           className="w-full p-2 text-sm text-gray-700 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 dark:bg-gray-700"
//         />

//         {/* SUBTITLE */}
//         <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
//   PNG, JPG, PDF, DOC, DOCX, TXT, CSV, XLS, XLSX — max 10 MB. 
//   Tip: you can paste a screenshot directly (Ctrl + V) instead of uploading.
// </p>
//       </div>

//       {/* Submit Button */}
//       <button
//         type="submit"
//         disabled={isSubmitting}
//         className={`w-full p-2 text-white rounded font-semibold transition-colors duration-200 ${
//           isSubmitting
//             ? "bg-gray-400 cursor-not-allowed"
//             : "bg-blue-600 hover:bg-blue-700"
//         }`}
//       >
//         {isSubmitting ? "Saving..." : "Create Task"}
//       </button>

//       {showNotifyModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md text-center dark:bg-gray-900 dark:text-white">
//             <div className="flex justify-end">
//               <button
//                 type="button"
//                 onClick={() => {
//                   setShowNotifyModal?.(false);
//                   setOpenForm?.(null);
//                 }}
//                 className="text-gray-600 hover:text-red-600 text-xl font-bold"
//                 aria-label="Close"
//               >
//                 &times;
//               </button>
//             </div>
//             <h2 className="text-lg font-semibold mb-4">
//               Notification Preference
//             </h2>
//             <p className="mb-4">
//               How would you like to notify{" "}
//               <span className="font-bold">{pendingParticipant.email}</span>?
//             </p>
//             <div className="flex justify-around gap-4">
//               <button
//                 onClick={() => confirmParticipant("both")}
//                 className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
//               >
//                 Notification + Email
//               </button>
//               <button
//                 onClick={() => confirmParticipant("email")}
//                 className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
//               >
//                 Email Only
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </form>
//   );
// }






import { useContext, useState, useEffect, useRef } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";
import Select from "react-select";
import { toast } from "react-toastify";

export default function TaskForm({
  leadId,
  showTaskForm,
  onTaskCreated,
  setOpenForm = null,
}) {
  const { user } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [statuses, setStatuses] = useState([]); // Store fetched statuses
  const [labels, setLabels] = useState([]); // Store fetched labels
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [formData, setFormData] = useState({
    companyId: user.accountType === "COMPANY" ? user.id : user.companyId,
    subject: "",
    priority: "Low",
    statusName: "",
    statusColor: "",
    labelName: "",
    labelColor: "",
    // startDate: "",
    endDate: "",
    description: "",
    file: null,
    createdById: user?.id,
    createdByName: user?.name,
    leadId: leadId || "",
    participants: [],
  });
  const [participantEmail, setParticipantEmail] = useState("");
  const [showNotifyModal, setShowNotifyModal] = useState(false);
  const [pendingParticipant, setPendingParticipant] = useState(null);
  const fileInputRef = useRef(null);

  // Allowed mime types & max size (bytes)
  // Update this constant near the top of the component
const ALLOWED_TYPES = [
  "image/png",
  "image/jpeg",
  "application/pdf",
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "text/plain", // .txt
  "text/csv", // .csv
  "application/vnd.ms-excel", // .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
];
  const MAX_SIZE = 10 * 1024 * 1024; // 5 MB

  // Clipboard-paste listener (mount once)
  useEffect(() => {
    function handlePaste(e) {
      const item = [...e.clipboardData.items].find(
        (i) => i.kind === "file" && i.type.startsWith("image/")
      );
      if (!item) return; // nothing to do

      const file = item.getAsFile();
      if (!file) return;

      // size check
      // In the useEffect for clipboard paste
if (file.size > MAX_SIZE) {
  toast.error("Image exceeds 10 MB limit");
  return;
}

      // save into your formData
      setFormData((prev) => ({ ...prev, file }));

      // OPTIONAL: point the hidden file input to the new file so
      // the browser's "chosen file" label shows something
      if (fileInputRef.current) {
        const dt = new DataTransfer();
        dt.items.add(file);
        fileInputRef.current.files = dt.files;
      }

      toast.success("Screenshot pasted!");
    }

    window.addEventListener("paste", handlePaste);
    return () => window.removeEventListener("paste", handlePaste);
  }, []);

  useEffect(() => {
    async function fetchStatusAndLabel() {
      const companyId =
        user?.accountType === "COMPANY" ? user.id : user?.companyId;
      // if (!companyId) return;

      try {
        const statusResponse = await axios.get(
          `${API_URL}/api/taskStatus/company/${companyId}`,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        const labelResponse = await axios.get(
          `${API_URL}/api/taskLabel/company/${companyId}`,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        setStatuses(statusResponse.data);
        setLabels(labelResponse.data);
      } catch (error) {
        console.error("Error fetching statuses and labels:", error);
      }
    }
    fetchStatusAndLabel();
  }, [user]);

  // Fetch Users
  useEffect(() => {
    async function fetchUsers() {
      if (!user?.id || !user?.accountType) return;
      const url =
        user?.accountType === "COMPANY"
          ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
          : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }
    fetchUsers();
  }, [user]);

  // Handle Form Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAssignedUsersChange = (selectedOptions) => {
    const assignedUsers = selectedOptions.map((option) => ({
      id: option.value,
      name: option.label,
    }));

    setFormData({
      ...formData,
      assignedToJson: JSON.stringify(assignedUsers),
    });
  };

  // Handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const taskData = new FormData();
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null && formData[key] !== undefined) {
          taskData.append(key, formData[key]);
        }
      });

      const response = await axios.post(`${API_URL}/api/tasks`, taskData, {
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data?.status === "Successful") {
        toast.success(response.data.message, {
          position: "top-center",
          autoClose: 5000,
        });

        // Reset form
        setFormData({
          companyId: user.accountType === "COMPANY" ? user.id : user.companyId,
          subject: "",
          priority: "Low",
          statusName: "",
          statusColor: "",
          labelName: "",
          labelColor: "",
          endDate: "",
          assignedToJson: JSON.stringify([]),
          description: "",
          file: null,
          createdById: user?.id,
          createdByName: user?.name,
          leadId: leadId || "",
          participants: [],
        });

        window.dispatchEvent(new Event("taskCreated"));

        // Callbacks
        onTaskCreated?.(response.data);
        showTaskForm?.(false);
        setOpenForm?.(null);
      } else {
        toast.error(response.data?.message);
      }
    } catch (error) {
      console.error("Task creation error:", error);
      toast.error(error.response?.data?.message || error.message, {
        position: "top-center",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Add Participant Handler
  const handleAddParticipant = () => {
    setEmailError(""); // Clear previous errors

    if (!participantEmail) {
      setEmailError("Please enter an email address");
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(participantEmail)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    // Check for duplicate emails
    const isDuplicate = formData.participants.some((participant) => {
      const email = Array.isArray(participant)
        ? participant[1] || participant[0]
        : participant;
      return email.toLowerCase() === participantEmail.toLowerCase();
    });

    if (isDuplicate) {
      setEmailError("This email is already added");
      return;
    }

    const matchedUser = users.find(
      (u) => u.email.toLowerCase() === participantEmail.toLowerCase()
    );
    if (matchedUser) {
      setPendingParticipant({ id: matchedUser.id, email: participantEmail });
      setShowNotifyModal(true);
    } else {
      setFormData((prev) => ({
        ...prev,
        participants: [...prev.participants, [participantEmail]],
      }));
      setParticipantEmail("");
    }
  };

  // Confirm Notification Choice
  const confirmParticipant = (type) => {
    let entry =
      type === "both"
        ? [pendingParticipant.id, pendingParticipant.email]
        : [pendingParticipant.email];

    setFormData((prev) => ({
      ...prev,
      participants: [...prev.participants, entry],
    }));

    setShowNotifyModal(false);
    setPendingParticipant(null);
    setParticipantEmail("");
  };

  // Filter active statuses for dropdown
  const activeStatuses = statuses.filter(status => status.active === true);

  return (
    <form
      onSubmit={handleSubmit}
      className="grid gap-4 p-4 w-full max-w-4xl mx-auto bg-white rounded-lg shadow-sm dark:bg-gray-800 "
    >
      {/* Subject Field */}
      <div className="w-full">
        <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
          Subject
        </label>
        <input
          type="text"
          name="subject"
          value={formData.subject}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-lg outline-none transition-all duration-200 hover:border-[#673AB7] focus:ring-1 focus:ring-[#673AB7] focus:border-[#673AB7] dark:bg-gray-700"
          placeholder="Subject"
        />
      </div>

      {/* Priority, Status, Label Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 dark:text-white">
        {/* Priority */}
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
            Priority
          </label>
          <select
            name="priority"
            value={formData.priority}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-lg outline-none transition-all duration-200 hover:border-[#673AB7] focus:ring-1 focus:ring-[#673AB7] focus:border-[#673AB7] App dark:bg-gray-700 dark:text-white"
          >
            <option value="Low">Low</option>
            <option value="Medium">Medium</option>
            <option value="High">High</option>
            
          </select>
        </div>

        {/* Status */}
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
            Status
          </label>
          <select
            name="statusName"
            value={formData.statusName}
            onChange={(e) => {
              const selectedStatus = activeStatuses.find(
                (status) => status.name === e.target.value
              );
              setFormData({
                ...formData,
                statusName: e.target.value,
                statusColor: selectedStatus ? selectedStatus.color : "",
              });
            }}
            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-lg outline-none transition-all duration-200 hover:border-[#673AB7] focus:ring-1 focus:ring-[#673AB7] focus:border-[#673AB7] App dark:bg-gray-700 dark:text-white"
          >
            <option value="">Select Status</option>
            {activeStatuses.map((status) => (
              <option
                key={status.taskStatusId || status.id}
                value={status.name}
                // style={{ backgroundColor: status.color, color: "white" }}
              >
                {status.name}
              </option>
            ))}
          </select>
          {formData.statusColor && (
            <div
              className="w-8 h-4 mt-2 rounded-lg"
              style={{ backgroundColor: formData.statusColor }}
            ></div>
          )}
        </div>

        {/* Label */}
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
            Label (Optional)
          </label>
          <select
            name="labelName"
            value={formData.labelName}
            onChange={(e) => {
              const selectedLabel = labels.find(
                (label) => label.name === e.target.value
              );
              setFormData({
                ...formData,
                labelName: e.target.value,
                labelColor: selectedLabel ? selectedLabel.color : "",
              });
            }}
            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-lg outline-none transition-all duration-200 hover:border-[#673AB7] focus:ring-1 focus:ring-[#673AB7] focus:border-[#673AB7] App dark:bg-gray-700 dark:text-white"
          >
            <option value="">Select Label</option>
            {labels.map((label) => (
              <option key={label.id} value={label.name}>
                {label.name}
              </option>
            ))}
          </select>
          {formData.labelColor && (
            <div
              className="w-8 h-4 mt-2 rounded-lg"
              style={{ backgroundColor: formData.labelColor }}
            ></div>
          )}
        </div>
      </div>

      {/* Date Fields */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
            End Date
          </label>
          <input
            type="date"
            name="endDate"
            value={formData.endDate}
            onChange={handleChange}
            min={new Date().toISOString().split("T")[0]}
            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-lg outline-none transition-all duration-200 hover:border-[#673AB7] focus:ring-1 focus:ring-[#673AB7] focus:border-[#673AB7] dark:bg-gray-700"
          />
        </div>
      </div>

      {/* Assign To */}
      <div className="w-full">
        <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
          Assign To
        </label>
        <Select
          isMulti
          name="assignedToJson"
          options={users.map((user) => ({
            value: user.id,
            label: `${user.fname} ${user.lname}`,
          }))}
          onChange={handleAssignedUsersChange}
          className="w-full p-2 dark:bg-gray-700"
          classNamePrefix="select"
          styles={{
            control: (base, state) => ({
              ...base,
              minHeight: "42px",
              padding: "2px 4px",
              borderRadius: "0.375rem", // Tailwind rounded-lg
              borderColor: "#d1d5db", // Tailwind gray-300
              backgroundColor: document.documentElement.classList.contains(
                "dark"
              )
                ? "#374151" // Tailwind gray-700
                : "white",
              color: document.documentElement.classList.contains("dark")
                ? "white"
                : "black",
              boxShadow: state.isFocused ? "0 0 0 1px #60a5fa" : "none", // Tailwind purple-400
              "&:hover": {
                borderColor: "#9ca3af", // Tailwind gray-400
              },
            }),
            menu: (base) => ({
              ...base,
              borderRadius: "0.375rem",
              marginTop: 4,
              backgroundColor: document.documentElement.classList.contains(
                "dark"
              )
                ? "#1f2937" // Tailwind gray-800
                : "white",
              color: document.documentElement.classList.contains("dark")
                ? "white"
                : "black",
            }),
            option: (base, { isFocused, isSelected }) => ({
              ...base,
              backgroundColor: isFocused
                ? document.documentElement.classList.contains("dark")
                  ? "#4b5563" // Tailwind gray-600
                  : "#f3f4f6" // Tailwind gray-100
                : isSelected
                ? "#60a5fa" // Tailwind purple-400
                : "transparent",
              color: document.documentElement.classList.contains("dark")
                ? "white"
                : "black",
              cursor: "pointer",
            }),
            multiValue: (base) => ({
              ...base,
              backgroundColor: document.documentElement.classList.contains(
                "dark"
              )
                ? "#6b7280" // Tailwind gray-500
                : "#e5e7eb", // Tailwind gray-200
              borderRadius: "0.375rem",
              padding: "2px 6px",
            }),
            multiValueLabel: (base) => ({
              ...base,
              color: document.documentElement.classList.contains("dark")
                ? "white"
                : "black",
            }),
            multiValueRemove: (base) => ({
              ...base,
              color: "#ef4444", // Tailwind red-500
              ":hover": {
                backgroundColor: "#f87171", // red-400
                color: "white",
              },
            }),
          }}
        />
      </div>

      {/* Participant Email Input */}
      <div className="w-full">
        <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
          Participant Email
        </label>
        <div className="flex gap-2">
          <input
            type="email"
            value={participantEmail}
            onChange={(e) => {
              setParticipantEmail(e.target.value);
              setEmailError(""); // Clear error when typing
            }}
            className={`w-full p-2 border rounded-lg dark:bg-gray-700 ${
              emailError ? "border-red-500" : "border-gray-300"
            }`}
            placeholder="Add participant email"
          />
          <button
            type="button"
            onClick={handleAddParticipant}
            className="px-3 py-2 bg-[#673AB7] text-white rounded-lg hover:bg-[#5e35a6]"
          >
            Add
          </button>
        </div>
        {emailError && (
          <p className="mt-1 text-sm text-red-600 dark:text-red-400">
            {emailError}
          </p>
        )}
      </div>

      {/* List of Added Participants */}
      {formData.participants.length > 0 && (
        <div className="mt-2 space-y-1">
          {formData.participants.map((participant, index) => {
            const email = Array.isArray(participant)
              ? participant[1] || participant[0]
              : participant;
            return (
              <div
                key={index}
                className="flex items-center justify-between bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded-lg"
              >
                <span className="text-sm text-gray-800 dark:text-white">
                  {email}
                </span>
                <button
                  type="button"
                  onClick={() => {
                    setFormData((prev) => ({
                      ...prev,
                      participants: prev.participants.filter(
                        (_, i) => i !== index
                      ),
                    }));
                  }}
                  className="text-red-500 hover:text-red-700 text-sm"
                  title="Remove"
                >
                  ❌
                </button>
              </div>
            );
          })}
        </div>
      )}
      {/* Description */}
      <div className="w-full">
        <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
          Description
        </label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-lg outline-none transition-all duration-200 hover:border-[#673AB7] focus:ring-1 focus:ring-[#673AB7] focus:border-[#673AB7] min-h-[100px] dark:bg-gray-700"
          placeholder="Enter description"
        ></textarea>
      </div>

      {/* File Upload */}
      <div className="w-full">
        <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
          Upload File
        </label>

        {/* FILE INPUT */}
        <input
          ref={fileInputRef}
          type="file"
          name="file"
          accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,.txt,.csv,.xls,.xlsx"
          onChange={(e) => {
            const file = e.target.files[0];
            if (!file) return;

            if (!ALLOWED_TYPES.includes(file.type)) {
              toast.error("Unsupported file type");
              e.target.value = ""; // reset chooser
              return;
            }
            if (file.size > MAX_SIZE) {
              toast.error("File exceeds 10 MB limit");
              e.target.value = "";
              return;
            }

            setFormData((prev) => ({ ...prev, file }));
          }}
          className="w-full p-2 text-sm text-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg outline-none transition-all duration-200 hover:border-[#673AB7] focus:ring-1 focus:ring-[#673AB7] focus:border-[#673AB7] file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-purple-50 file:text-[#5e35a6] hover:file:bg-purple-100 dark:bg-gray-700"
        />

        {/* SUBTITLE */}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
  PNG, JPG, PDF, DOC, DOCX, TXT, CSV, XLS, XLSX — max 10 MB. 
  Tip: you can paste a screenshot directly (Ctrl + V) instead of uploading.
</p>
      </div>

      {/* Submit Button */}
      <button
        type="submit"
        disabled={isSubmitting}
        className={`w-full p-2 text-white rounded-lg font-semibold transition-colors duration-200 ${
          isSubmitting
            ? "bg-gray-400 cursor-not-allowed"
            : "bg-[#673AB7] hover:bg-[#5e35a6]"
        }`}
      >
        {isSubmitting ? "Saving..." : "Create Task"}
      </button>

      {showNotifyModal && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 backdrop-blur-sm animate-fade-in">
          <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md text-center dark:bg-gray-900 dark:text-white">
            <div className="flex justify-end">
              <button
                type="button"
                onClick={() => {
                  setShowNotifyModal?.(false);
                  setOpenForm?.(null);
                }}
                className="text-gray-600 hover:text-red-600 text-xl font-bold"
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            <h2 className="text-lg font-semibold mb-4">
              Notification Preference
            </h2>
            <p className="mb-4">
              How would you like to notify{" "}
              <span className="font-bold">{pendingParticipant.email}</span>?
            </p>
            <div className="flex justify-around gap-4">
              <button
                onClick={() => confirmParticipant("both")}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
              >
                Notification + Email
              </button>
              <button
                onClick={() => confirmParticipant("email")}
                className="px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600"
              >
                Email Only
              </button>
            </div>
          </div>
        </div>
      )}
    </form>
  );
}